// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__EguBl","errorLogs":"EditorFooter_errorLogs__JFeDX"};